import { getElementById } from '../utils/get-element-by-id';
import { evt_Click } from '../constants/event-names';

/**
 * The content of annotation dialogs should be empty to prevent dialogs
 * from opening/closing.
 */
const DIALOG_CONTENT = '';

/**
 * All custom hotspots should have this custom default css class.
 * Keep in mind, that new annoations already come with the following class:
 *
 */
const HOTSPOT_CLASS = 'std-hotspot';

const HOTSPOT_TYPES = ['eye', 'scissor', 'power', 'info', 'plus', 'minus'];

export const createHotspot = ({
  app,
  hotspot: { placeholderIn3D, textIdentifier, textLabel, htmlId, htmlClass },
}: {
  app: Verge.App;
  hotspot: Hotspot;
}) => {
  const { container, scene } = app;

  if (HOTSPOT_TYPES.indexOf(htmlClass) > -1 && textIdentifier !== '') {
    throw new Error('Custom hotspot types should not contain an abbreviation!');
  } else if (HOTSPOT_TYPES.indexOf(htmlClass) === -1 && textIdentifier === '') {
    throw new Error('Default hotspot should always have an abbreviation!');
  }

  // Instead of an ordinary text inside a hotspot, we want to insert further HTML tags.
  const innerHTML = `<div class="first ${htmlClass}">${textIdentifier}</div>
    <div class="second">${textLabel}</div>`;

  // 1. Get the 3D position for the upcoming hotspot by name
  // 2. Create a new hotspot and assign some data, similar to the statements
  // in visual_logic.js, if the addAnnoation puzzle piece is in use.
  const obj = scene.getObjectByName(placeholderIn3D);
  if (!obj) {
    throw new Error(`Could not find 3D object by name: ${placeholderIn3D}`);
  }
  const aObj = new window.v3d.Annotation(container, innerHTML, DIALOG_CONTENT);
  aObj.name = `${placeholderIn3D}_annotation`;
  // aObj.fadeObscured = _pGlob.fadeAnnotations;
  aObj.annotation.id = htmlId;
  aObj.annotationDialog.id = `${htmlId}_dialog`;

  // Assign custom css style to the new 2,5D hotspot.
  const element = getElementById(htmlId);
  element.classList.add(HOTSPOT_CLASS);

  // Listen for click events and call a function, which can also be invoked by Verge3D puzzles.
  // This will trigger a custom event, which is then consumed by another listener.
  // TODO we could avoid this indirect call and remove the onHotspotClick method completely.
  // If and only if everyone agrees to not call this function anymore through the Verge3D
  // puzzles editor.
  element.addEventListener(evt_Click, (e) => {
    const target = e.target as HTMLDivElement | null;
    if (target) {
      app.ExternalInterface.onHotspotClick(target.id);
    }
  });

  // Place the billboarding hotspot to its 3D position.
  // By the way, using `scene.add(aObj);` would place the hotspot in the 3D origin.
  obj.add(aObj);
};
